import React, { useState } from "react";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { MessageSquarePlus } from "lucide-react";
import { api } from "@/lib/api";
import { useDemo } from "@/context/DemoContext";
import { toast } from "sonner";

export default function FeedbackButton({ schermata, ticketId = "" }) {
  const { profile } = useDemo();
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState({ categoria: "Passaggio scomodo", descrizione: "", atteso: "" });

  const submit = async () => {
    if (!form.descrizione.trim()) { toast.error("Descrizione obbligatoria"); return; }
    await api.post("/feedback", {
      schermata, ticket_id: ticketId, ...form, profilo: profile.nome,
    });
    toast.success("Feedback salvato");
    setOpen(false);
    setForm({ categoria: "Passaggio scomodo", descrizione: "", atteso: "" });
  };

  return (
    <>
      <Button variant="outline" size="sm" onClick={() => setOpen(true)} data-testid="feedback-btn">
        <MessageSquarePlus className="w-4 h-4 mr-1.5" /> Segnala un problema
      </Button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent data-testid="feedback-dialog">
          <DialogHeader><DialogTitle>Segnala un problema</DialogTitle></DialogHeader>
          <div className="space-y-3">
            <div className="text-xs text-slate-500">Schermata: <span className="font-medium">{schermata}</span>{ticketId && <> · Ticket: <span className="font-mono">{ticketId}</span></>}</div>
            <div>
              <Label>Categoria</Label>
              <Select value={form.categoria} onValueChange={v => setForm({ ...form, categoria: v })}>
                <SelectTrigger data-testid="feedback-cat"><SelectValue /></SelectTrigger>
                <SelectContent>
                  <SelectItem value="Informazione mancante">Informazione mancante</SelectItem>
                  <SelectItem value="Passaggio scomodo">Passaggio scomodo</SelectItem>
                  <SelectItem value="Errore">Errore</SelectItem>
                  <SelectItem value="Proposta">Proposta</SelectItem>
                </SelectContent>
              </Select>
            </div>
            <div>
              <Label>Descrizione</Label>
              <Textarea value={form.descrizione} onChange={e => setForm({ ...form, descrizione: e.target.value })} data-testid="feedback-desc" />
            </div>
            <div>
              <Label>Cosa ti aspettavi?</Label>
              <Textarea value={form.atteso} onChange={e => setForm({ ...form, atteso: e.target.value })} data-testid="feedback-atteso" />
            </div>
          </div>
          <DialogFooter>
            <Button variant="outline" onClick={() => setOpen(false)}>Annulla</Button>
            <Button onClick={submit} data-testid="feedback-submit">Invia feedback</Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </>
  );
}
